<header>
    <nav class="border-gray-200 px-4 lg:px-6 py-2.5">
        <div class="flex flex-wrap items-center mx-auto max-w-screen-xl"
            [ngClass]="!isLogged ? 'justify-start' : newTitle || newTitle == '' ? 'justify-between' : 'justify-end'">
            <a *ngIf="!isLogged" class="flex items-center">
                <img src="./assets/svg/tagline.svg" class="w-[142px] h-[50px]" alt="AVLA Logo" />
            </a>

            <a *ngIf="isLogged && (newTitle || newTitle == '')" [routerLink]="['/' + routes.HOME]" class="flex items-center">
                <img src="./assets/svg/tagline.svg" class="mr-3 h-6 sm:h-9" alt="AVLA Logo" />
            </a>

            <h3 *ngIf="newTitle">{{newTitle}}</h3>

            <div *ngIf="!isLogged" class="flex flex-row gap-7 ml-auto text-gray-9 text-m font-medium text-grey-9">
                <a (click)="scrollToElement('why')" class="cursor-pointer">¿Por qué?</a>
                <a (click)="scrollToElement('what')" class="cursor-pointer">¿Qué es?</a>
                <a (click)="scrollToElement('how')" class="cursor-pointer">¿Cómo funciona?</a>
            </div>

            <div *ngIf="isLogged" class="flex flex-row gap-4">
                <app-menu-venta></app-menu-venta>
                <button
                    class="bg-gray-6 rounded-full py-1 px-[0.35rem] flex items-center shadow-fution-small hover:bg-light-blue hover:opacity-70 focus:bg-light-blue"
                    (mouseenter)="hovered = true" (mouseleave)="hovered = false" (focus)="focused = true" (blur)="focused = false" (click)="openModal()">
                    <img class="w-[1.3rem]" src="./assets/svg/comment-dark.svg" alt="comment"
                        [ngClass]="{'hidden': hovered || focused}">
                    <img class="w-[1.3rem]" src="./assets/svg/comment.svg" alt="comment"
                        [ngClass]="{'hidden': !hovered && !focused}">
                </button>
                <app-menu-help></app-menu-help>
                <app-menu-user></app-menu-user>
                <button *ngIf="newTitle || newTitle == ''" class="bg-light-blue text-lighter rounded-full p-1 flex items-center shadow-fution-small hover:bg-blue-hover focus:bg-light-blue" [routerLink]="['/' + routes.HOME]">
                    <span class="material-symbols-rounded leading-none">home</span>
                </button>
            </div>
        </div>
    </nav>
</header>